import React, { useState } from 'react';
import { MapPinIcon, BedIcon, BathIcon, CheckCircleIcon, CalendarIcon, ClockIcon, CreditCardIcon, GavelIcon, UserIcon, MessageSquareIcon, HeartIcon, ShareIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import VirtualTourViewer from '../components/VirtualTour/VirtualTourViewer';
// Mock property data
const property = {
  id: 1,
  title: 'Luxury 3 Bedroom Apartment with Ocean View',
  location: 'Lekki Phase 1, Lagos',
  price: '₦75,000,000',
  bedrooms: 3,
  bathrooms: 3,
  area: '180 sqm',
  images: ['https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1613553507747-5f8d62ad5904?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80', 'https://images.unsplash.com/photo-1603825491103-bd638b1873b0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80'],
  description: "This luxurious 3-bedroom apartment offers breathtaking views of the Atlantic Ocean from its spacious balcony. Located in the heart of Lekki Phase 1, this property features modern finishes, a fully fitted kitchen with high-end appliances, and 24/7 power supply. The complex includes amenities such as a swimming pool, gym, and round-the-clock security. Perfect for professionals or families looking for comfort and convenience in one of Lagos' most sought-after neighborhoods.",
  features: ['24/7 Power Supply', 'Swimming Pool', 'Gym', 'Security', 'Fully Fitted Kitchen', 'Air Conditioning', 'Parking Space', 'Elevator'],
  verified: true,
  agent: {
    name: 'Victoria Estates',
    phone: '+234 801 234 5678',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80'
  },
  has3DTour: true
};
const PropertyDetails = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [selectedTab, setSelectedTab] = useState('overview');
  const [showVirtualTour, setShowVirtualTour] = useState(false);
  const nextImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === property.images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prevIndex => prevIndex === 0 ? property.images.length - 1 : prevIndex - 1);
  };
  const toggleVirtualTour = () => {
    setShowVirtualTour(!showVirtualTour);
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1554">
      <div className="container mx-auto px-4 py-8" data-id="element-1555">
        {/* Navigation */}
        <div className="mb-6" data-id="element-1556">
          <Link to="/properties" className="text-[#FF4E00] hover:underline flex items-center" data-id="element-1557">
            <ChevronLeftIcon size={20} className="mr-1" data-id="element-1558" />
            Back to Properties
          </Link>
        </div>
        {/* Property Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6" data-id="element-1559">
          <div data-id="element-1560">
            <div className="flex items-center mb-2" data-id="element-1561">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mr-3" data-id="element-1562">
                {property.title}
              </h1>
              {property.verified && <div className="flex items-center text-[#FF4E00] bg-[#FFF1EC] px-2 py-1 rounded" data-id="element-1563">
                  <CheckCircleIcon size={16} className="mr-1" data-id="element-1564" />
                  <span className="text-xs font-medium" data-id="element-1565">Verified</span>
                </div>}
            </div>
            <div className="flex items-center text-gray-600" data-id="element-1566">
              <MapPinIcon size={18} className="mr-1" data-id="element-1567" />
              <span data-id="element-1568">{property.location}</span>
            </div>
          </div>
          <div className="mt-4 md:mt-0" data-id="element-1569">
            <div className="text-2xl md:text-3xl font-bold text-[#FF4E00]" data-id="element-1570">
              {property.price}
            </div>
          </div>
        </div>
        {/* Property Images or 3D Tour */}
        <div className="relative mb-8" data-id="element-1571">
          {showVirtualTour ? <div className="rounded-lg overflow-hidden h-64 md:h-96" data-id="element-1572">
              <VirtualTourViewer data-id="element-1573" />
            </div> : <div className="rounded-lg overflow-hidden h-64 md:h-96" data-id="element-1574">
              <img src={property.images[currentImageIndex]} alt={property.title} className="w-full h-full object-cover" data-id="element-1575" />
            </div>}
          {/* Toggle 3D Tour Button */}
          {property.has3DTour && <button onClick={toggleVirtualTour} className="absolute top-4 right-4 bg-white bg-opacity-90 text-gray-800 px-3 py-2 rounded-lg shadow-md hover:bg-opacity-100 flex items-center" data-id="element-1576">
              <div size={18} className="mr-2" data-id="element-1577" />
              {showVirtualTour ? 'View Photos' : 'View 3D Tour'}
            </button>}
          {/* Image Navigation Controls (only show when not in 3D tour mode) */}
          {!showVirtualTour && <>
              <button onClick={prevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100" data-id="element-1578">
                <ChevronLeftIcon size={24} data-id="element-1579" />
              </button>
              <button onClick={nextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-md hover:bg-gray-100" data-id="element-1580">
                <ChevronRightIcon size={24} data-id="element-1581" />
              </button>
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2" data-id="element-1582">
                {property.images.map((_, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`w-2 h-2 rounded-full ${index === currentImageIndex ? 'bg-white' : 'bg-white bg-opacity-50'}`} data-id="element-1583" />)}
              </div>
            </>}
        </div>
        {/* Thumbnail Preview (only show when not in 3D tour mode) */}
        {!showVirtualTour && <div className="flex space-x-2 mb-8 overflow-x-auto pb-2" data-id="element-1584">
            {property.images.map((image, index) => <button key={index} onClick={() => setCurrentImageIndex(index)} className={`flex-shrink-0 w-20 h-20 rounded-md overflow-hidden ${index === currentImageIndex ? 'ring-2 ring-[#FF4E00]' : ''}`} data-id="element-1585">
                <img src={image} alt={`${property.title} - Image ${index + 1}`} className="w-full h-full object-cover" data-id="element-1586" />
              </button>)}
          </div>}
        <div className="flex flex-col lg:flex-row space-y-8 lg:space-y-0 lg:space-x-8" data-id="element-1587">
          {/* Main Content */}
          <div className="lg:w-2/3" data-id="element-1588">
            {/* Property Features */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1589">
              <div className="flex justify-between items-center mb-6" data-id="element-1590">
                <div className="flex space-x-8" data-id="element-1591">
                  <div className="flex items-center" data-id="element-1592">
                    <BedIcon size={20} className="text-gray-600 mr-2" data-id="element-1593" />
                    <div data-id="element-1594">
                      <div className="font-bold" data-id="element-1595">{property.bedrooms}</div>
                      <div className="text-sm text-gray-600" data-id="element-1596">Bedrooms</div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1597">
                    <BathIcon size={20} className="text-gray-600 mr-2" data-id="element-1598" />
                    <div data-id="element-1599">
                      <div className="font-bold" data-id="element-1600">{property.bathrooms}</div>
                      <div className="text-sm text-gray-600" data-id="element-1601">Bathrooms</div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1602">
                    <div size={20} className="text-gray-600 mr-2" data-id="element-1603" />
                    <div data-id="element-1604">
                      <div className="font-bold" data-id="element-1605">{property.area}</div>
                      <div className="text-sm text-gray-600" data-id="element-1606">Area</div>
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-1607">
                  <button className="p-2 text-gray-600 hover:text-[#FF4E00] hover:bg-[#FFF1EC] rounded-full" data-id="element-1608">
                    <HeartIcon size={20} data-id="element-1609" />
                  </button>
                  <button className="p-2 text-gray-600 hover:text-[#FF4E00] hover:bg-[#FFF1EC] rounded-full" data-id="element-1610">
                    <ShareIcon size={20} data-id="element-1611" />
                  </button>
                </div>
              </div>
            </div>
            {/* Tabs */}
            <div className="mb-6" data-id="element-1612">
              <div className="flex border-b overflow-x-auto" data-id="element-1613">
                {['overview', 'virtual tour', 'features', 'legal', 'payment'].map(tab => <button key={tab} className={`px-4 py-2 font-medium whitespace-nowrap ${selectedTab === tab ? 'text-[#FF4E00] border-b-2 border-[#FF4E00]' : 'text-gray-600 hover:text-[#FF4E00]'}`} onClick={() => setSelectedTab(tab)} data-id="element-1614">
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>)}
              </div>
            </div>
            {/* Tab Content */}
            <div className="bg-white rounded-lg shadow-sm p-6 mb-8" data-id="element-1615">
              {selectedTab === 'overview' && <div data-id="element-1616">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1617">
                    Property Description
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-1618">{property.description}</p>
                  <div data-id="element-1619">
                    <h3 className="text-lg font-medium mb-3" data-id="element-1620">
                      Location Details
                    </h3>
                    <div className="bg-gray-100 h-64 rounded-lg mb-4" data-id="element-1621">
                      {/* Map placeholder */}
                      <div className="w-full h-full flex items-center justify-center text-gray-500" data-id="element-1622">
                        Interactive Map Placeholder
                      </div>
                    </div>
                    <p className="text-gray-700" data-id="element-1623">
                      Located in Lekki Phase 1, this property is within walking
                      distance to shopping malls, restaurants, and schools. It's
                      approximately 35 minutes from Murtala Muhammed
                      International Airport and 15 minutes from Victoria Island.
                    </p>
                  </div>
                </div>}
              {selectedTab === 'virtual tour' && <div data-id="element-1624">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1625">3D Virtual Tour</h2>
                  <p className="text-gray-700 mb-6" data-id="element-1626">
                    Explore every corner of this property with our immersive 3D
                    virtual tour. Use your mouse to navigate around the space
                    and get a real feel for the layout and dimensions.
                  </p>
                  <div className="rounded-lg overflow-hidden h-96 mb-6" data-id="element-1627">
                    <VirtualTourViewer fullScreen={true} data-id="element-1628" />
                  </div>
                  <div className="bg-blue-50 rounded-lg p-4" data-id="element-1629">
                    <h3 className="font-medium text-blue-800 mb-2" data-id="element-1630">
                      Navigation Tips:
                    </h3>
                    <ul className="list-disc pl-5 text-blue-800 text-sm space-y-1" data-id="element-1631">
                      <li data-id="element-1632">Click and drag to look around</li>
                      <li data-id="element-1633">Use the controls to move between rooms</li>
                      <li data-id="element-1634">Double-click on points of interest to zoom in</li>
                      <li data-id="element-1635">
                        Use the floor plan to quickly navigate to different
                        areas
                      </li>
                    </ul>
                  </div>
                </div>}
              {selectedTab === 'features' && <div data-id="element-1636">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1637">Property Features</h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-1638">
                    {property.features.map((feature, index) => <div key={index} className="flex items-center" data-id="element-1639">
                        <CheckCircleIcon size={18} className="text-[#FF4E00] mr-2" data-id="element-1640" />
                        <span className="text-gray-700" data-id="element-1641">{feature}</span>
                      </div>)}
                  </div>
                </div>}
              {selectedTab === 'legal' && <div data-id="element-1642">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1643">Legal Verification</h2>
                  <p className="text-gray-700 mb-6" data-id="element-1644">
                    All properties on DiasporaHomes undergo thorough legal
                    verification. For this property, you can choose from our
                    network of trusted law firms to conduct document
                    verification and handle the legal aspects of your purchase.
                  </p>
                  <div className="bg-[#FFF1EC] border border-[#FFCDB7] rounded-lg p-4 mb-6" data-id="element-1645">
                    <div className="flex items-center text-[#FF4E00] mb-2" data-id="element-1646">
                      <GavelIcon size={18} className="mr-2" data-id="element-1647" />
                      <span className="font-medium" data-id="element-1648">
                        Legal Verification Process
                      </span>
                    </div>
                    <ol className="list-decimal list-inside text-gray-700 space-y-2 pl-6" data-id="element-1649">
                      <li data-id="element-1650">Select a trusted law firm from our network</li>
                      <li data-id="element-1651">
                        Law firm conducts comprehensive document verification
                      </li>
                      <li data-id="element-1652">Receive detailed legal report on the property</li>
                      <li data-id="element-1653">Legal team handles all necessary paperwork</li>
                      <li data-id="element-1654">Secure transfer of ownership documents</li>
                    </ol>
                  </div>
                  <button className="bg-[#FF4E00] text-white px-4 py-2 rounded-lg hover:bg-[#e64600] transition" data-id="element-1655">
                    Select Law Firm
                  </button>
                </div>}
              {selectedTab === 'payment' && <div data-id="element-1656">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1657">
                    Secure Payment Options
                  </h2>
                  <p className="text-gray-700 mb-6" data-id="element-1658">
                    DiasporaHomes uses a secure escrow payment system to protect
                    your investment. Funds are only released to the seller after
                    all conditions have been met and verified.
                  </p>
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-1659">
                    <div className="flex items-center text-blue-800 mb-2" data-id="element-1660">
                      <CreditCardIcon size={18} className="mr-2" data-id="element-1661" />
                      <span className="font-medium" data-id="element-1662">
                        Escrow Payment Process
                      </span>
                    </div>
                    <ol className="list-decimal list-inside text-gray-700 space-y-2 pl-6" data-id="element-1663">
                      <li data-id="element-1664">Deposit funds into secure escrow account</li>
                      <li data-id="element-1665">Funds held securely during verification process</li>
                      <li data-id="element-1666">Legal verification completed by selected law firm</li>
                      <li data-id="element-1667">Property inspection and documentation review</li>
                      <li data-id="element-1668">Funds released only after buyer confirmation</li>
                    </ol>
                  </div>
                  <button className="bg-[#FF4E00] text-white px-4 py-2 rounded-lg hover:bg-[#e64600] transition" data-id="element-1669">
                    Proceed to Payment
                  </button>
                </div>}
            </div>
          </div>
          {/* Sidebar */}
          <div className="lg:w-1/3 space-y-8" data-id="element-1670">
            {/* Agent Information */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1671">
              <h2 className="text-lg font-bold mb-4" data-id="element-1672">Property Agent</h2>
              <div className="flex items-center mb-4" data-id="element-1673">
                <img src={property.agent.image} alt={property.agent.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-1674" />
                <div data-id="element-1675">
                  <h3 className="font-medium" data-id="element-1676">{property.agent.name}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-1677">Verified Agent</p>
                </div>
              </div>
              <div className="space-y-4" data-id="element-1678">
                <button className="w-full bg-[#FF4E00] text-white px-4 py-2 rounded-lg hover:bg-[#e64600] transition flex items-center justify-center" data-id="element-1679">
                  <MessageSquareIcon size={18} className="mr-2" data-id="element-1680" />
                  Contact Agent
                </button>
                <button className="w-full bg-white border border-gray-300 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-50 transition" data-id="element-1681">
                  {property.agent.phone}
                </button>
              </div>
            </div>
            {/* Schedule Viewing */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1682">
              <h2 className="text-lg font-bold mb-4" data-id="element-1683">
                Schedule a Virtual Tour
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-1684">
                Can't visit in person? Schedule a live video tour with our local
                agent.
              </p>
              <form className="space-y-4" data-id="element-1685">
                <div data-id="element-1686">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1687">
                    Preferred Date
                  </label>
                  <div className="relative" data-id="element-1688">
                    <input type="text" placeholder="Select date" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1689" />
                    <CalendarIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1690" />
                  </div>
                </div>
                <div data-id="element-1691">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1692">
                    Preferred Time
                  </label>
                  <div className="relative" data-id="element-1693">
                    <input type="text" placeholder="Select time" className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FF4E00]" data-id="element-1694" />
                    <ClockIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1695" />
                  </div>
                </div>
                <button className="w-full bg-[#FF4E00] text-white px-4 py-2 rounded-lg hover:bg-[#e64600] transition" data-id="element-1696">
                  Schedule Tour
                </button>
              </form>
            </div>
            {/* Purchase Steps */}
            <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-1697">
              <h2 className="text-lg font-bold mb-4" data-id="element-1698">Purchase Process</h2>
              <div className="space-y-4" data-id="element-1699">
                <div className="flex" data-id="element-1700">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF1EC] text-[#FF4E00] flex items-center justify-center font-bold mr-3" data-id="element-1701">
                    1
                  </div>
                  <div data-id="element-1702">
                    <h3 className="font-medium" data-id="element-1703">Contact Agent</h3>
                    <p className="text-sm text-gray-600" data-id="element-1704">
                      Discuss property details and arrange viewing
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-1705">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF1EC] text-[#FF4E00] flex items-center justify-center font-bold mr-3" data-id="element-1706">
                    2
                  </div>
                  <div data-id="element-1707">
                    <h3 className="font-medium" data-id="element-1708">Legal Verification</h3>
                    <p className="text-sm text-gray-600" data-id="element-1709">
                      Select a law firm to verify all documents
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-1710">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF1EC] text-[#FF4E00] flex items-center justify-center font-bold mr-3" data-id="element-1711">
                    3
                  </div>
                  <div data-id="element-1712">
                    <h3 className="font-medium" data-id="element-1713">Secure Payment</h3>
                    <p className="text-sm text-gray-600" data-id="element-1714">
                      Pay through our secure escrow system
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-1715">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#FFF1EC] text-[#FF4E00] flex items-center justify-center font-bold mr-3" data-id="element-1716">
                    4
                  </div>
                  <div data-id="element-1717">
                    <h3 className="font-medium" data-id="element-1718">Document Delivery</h3>
                    <p className="text-sm text-gray-600" data-id="element-1719">
                      Secure delivery of all property documents
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PropertyDetails;